import { FontIcon } from '@fluentui/react';
import { Tag } from '../Tag';
import {
  AppCardContainer,
  AppCardContent,
  AppCardHeader,
  AppCardTagContainer,
} from './styles';
import { AppModal } from '../AppModal';
import { useBoolean } from '@fluentui/react-hooks';
import { callFunction } from '../../lib/Helpers';
import { useContext, useEffect, useState } from 'react';
import { Skeleton } from '../../../styles/components';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { app } from '@microsoft/teams-js';
import { TeamsFxContext } from '../../Context';
import { isMobile } from 'react-device-detect';

export interface AppObject {
  id: string;
  name: string;
  group: string;
  status: string;
  description: string;
  longdescription: string;
  pictures: string[];
  demo: string;
  img: string;
  tag: string;
  tagColor: string;
  key: string;
  iconName: string;
  hasconfigpage: boolean;
  hasui: boolean;
  configpage: string;
}

interface AppCardProps {
  data?: AppObject;
  isOwner?: boolean;
  tenantId?: string;
  themeName?: string;
  onError: React.Dispatch<React.SetStateAction<string>>;
  context?: app.Context;
  index?: number;
}

export interface IAppPlan {
  users: string[];
  plans: {
    appid: string;
    description: string;
    displayName: string;
    isPrivate: boolean;
    monthlyPrice: number;
    planId: string;
    privateTenants: string[];
    status: string;
    yearlyPrice: number;
  }[];
}

export const AppCard = ({
  data,
  tenantId,
  isOwner,
  themeName,
  index,
}: AppCardProps) => {
  const appInsights = useAppInsightsContext();

  const { teamsUserCredential, locale } = useContext(TeamsFxContext);

  const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] =
    useBoolean(false);

  const [appPlans, setAppPlans] = useState<any>();
  const [admins, setAdmins] = useState<string[]>([]);

  useEffect(() => {
    let mounted = true;
    if (data?.id && tenantId) {
      callFunction(
        true,
        'getAppPlans?{0}&appid=' + data?.id + '&tenantid=' + tenantId,
        undefined,
        undefined,
        teamsUserCredential
      )
        .then((plans) => {
          if (mounted) {
            setAppPlans(plans);
            setAdmins(plans.users);
          }
        })
        .catch((error) => {
          if (process.env.REACT_APP_APP_INSIGHTS !== '')
            appInsights.trackException({
              exception: error,
              properties: {
                component: 'AppCard',
                location: 'onGetPlansUseEffect',
              },
            });
        });
    }

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <AppCardContainer
      id={index === 0 ? 'step-open-app-modal' : ''}
      onClick={() => showModal()}
    >
      <AppCardContent>
        <AppCardHeader>
          <div className="iconWrapper">
            {data && (
              <FontIcon
                style={{ color: 'FFFFFF', fontSize: 30 }}
                iconName={data.iconName}
              />
            )}
          </div>
          {data ? (
            <>
              <h1>{data.name}</h1>
              <h2>{data.group}</h2>
            </>
          ) : (
            <>
              <Skeleton height={1.2} />
              <Skeleton height={0.9} />
            </>
          )}
        </AppCardHeader>
        {data ? (
          <p>{data.description}</p>
        ) : (
          <div className="skeletonWrapper">
            <Skeleton height={1.2} />
            <Skeleton height={1.2} />
          </div>
        )}
      </AppCardContent>
      <AppCardTagContainer>
        {data && <Tag content={data.tag} color={data.tagColor} />}
      </AppCardTagContainer>
      {tenantId && (
        <AppModal
          app={data}
          admins={admins}
          plans={appPlans}
          tenantId={tenantId}
          isOpen={isModalOpen}
          closeModal={hideModal}
          isOwner={isOwner ?? false}
          themeName={themeName ?? 'default'}
          isMobile={isMobile}
        />
      )}
    </AppCardContainer>
  );
};
